<template>
  <GbwapsLayout title="About GBWaps" :intro="pageIntro" :breadcrumb="breadcrumb">
    <div class="about-page">
      <section
        v-for="section in sections"
        :id="section.id"
        :key="section.id"
        class="page-section site-section"
      >
        <h2>{{ section.h2 }}</h2>
        <ContentBlocks :blocks="section.blocks" />

        <ul v-if="section.list" class="about-list">
          <li v-for="(item, idx) in section.list" :key="idx">{{ item }}</li>
        </ul>

        <p v-if="section.footerLinks" class="about-related">
          <template v-for="(link, idx) in section.footerLinks">
            <router-link :key="link.to" :to="link.to">{{ link.text }}</router-link>
            <span v-if="idx < section.footerLinks.length - 1" :key="'sep-' + link.to"> · </span>
          </template>
        </p>
      </section>

      <div class="warning-box about-notice">
        <strong>Notice:</strong>
        GBWaps is not affiliated with WhatsApp or Meta Platforms, Inc. This is an independent informational website.
      </div>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import { ABOUT_SECTIONS } from '@/data/about-content';

export default {
  name: 'AboutPage',
  components: { GbwapsLayout, ContentBlocks },
  data() {
    return {
      pageIntro:
        'GBWaps is an independent Android guide site for GB WhatsApp download, install, updates, and fixes — not affiliated with WhatsApp or Meta.',
      breadcrumb: [{ name: 'About' }],
      sections: ABOUT_SECTIONS,
    };
  },
};
</script>

<style scoped>
.about-list {
  margin: 16px 0 0;
  padding-left: 1.25rem;
  line-height: 1.65;
}

.about-list li {
  margin-bottom: 8px;
}

.about-related {
  margin-top: 16px;
}

.about-notice {
  margin-top: 32px;
}
</style>
